import {appointment} from '@/stores/appointment/appointment'

export default {

  setServiceFormState(filterObj) {
      this.commitMutation('setServiceFormState',filterObj )
  
  },
  setMedia(data) {
    this.commitMutation('setMedia', data )
},

  removeMedia(data) {
    this.commitMutation('removeMedia', data )
},
  resetMedia(data) {
    this.commitMutation('resetMedia', data )
},
  setUserId(userId) {
    this.commitMutation('setUserId',userId)
  },

  async addService(serviceName) {
    // check if this service already exists in the array
    const store = appointment()

    const serviceExists = store?.selectedServices?.some(service => service === serviceName)

    if(serviceExists) {
      return
    }

    this.commitMutation('addService',serviceName )

  },


  updateMultiSelection(filterObj) {
    this.commitMutation('updateMultiSelection',filterObj)
  },

  removeService(serviceName) {
    this.commitMutation('clearServiceState', serviceName)
    this.commitMutation('removeService',serviceName )
  },

}